"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictionaryTypes = exports.DictionaryStatuses = void 0;
var DictionaryStatuses;
(function (DictionaryStatuses) {
    DictionaryStatuses["created"] = "created";
    DictionaryStatuses["downloading"] = "downloading";
    DictionaryStatuses["importing"] = "importing";
    DictionaryStatuses["importError"] = "importError";
    DictionaryStatuses["ready"] = "ready";
    DictionaryStatuses["compiling"] = "compiling";
    DictionaryStatuses["compiled"] = "compiled";
    DictionaryStatuses["compileError"] = "compileError";
    DictionaryStatuses["activated"] = "activated";
})(DictionaryStatuses || (exports.DictionaryStatuses = DictionaryStatuses = {}));
var DictionaryTypes;
(function (DictionaryTypes) {
    DictionaryTypes["phone:mnp"] = "phone:mnp";
    DictionaryTypes["phone:ranges"] = "phone:ranges";
    DictionaryTypes["phone:opgroups"] = "phone:opgroups";
})(DictionaryTypes || (exports.DictionaryTypes = DictionaryTypes = {}));
//# sourceMappingURL=dictionaries.enum.js.map